/* global window, document */
import isBrowser from './is-browser';

export var isPageLoaded = false;

export var pageLoadPromise = isBrowser ? new Promise(function (resolve, reject) {
  window.onload = function () {
    isPageLoaded = true;
    resolve(document);
  };
}) : Promise.resolve({});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9icm93c2VyLXV0aWxzLmpzIl0sIm5hbWVzIjpbImlzQnJvd3NlciIsImlzUGFnZUxvYWRlZCIsInBhZ2VMb2FkUHJvbWlzZSIsIlByb21pc2UiLCJyZXNvbHZlIiwicmVqZWN0Iiwid2luZG93Iiwib25sb2FkIiwiZG9jdW1lbnQiXSwibWFwcGluZ3MiOiJBQUFBO0FBQ0EsT0FBT0EsU0FBUCxNQUFzQixjQUF0Qjs7QUFFQSxPQUFPLElBQUlDLGVBQWUsS0FBbkI7O0FBRVAsT0FBTyxJQUFNQyxrQkFBa0JGLFlBQzdCLElBQUlHLE9BQUosQ0FBWSxVQUFDQyxPQUFELEVBQVVDLE1BQVYsRUFBcUI7QUFDL0JDLFNBQU9DLE1BQVAsR0FBZ0IsWUFBTTtBQUNwQk4sbUJBQWUsSUFBZjtBQUNBRyxZQUFRSSxRQUFSO0FBQ0QsR0FIRDtBQUlELENBTEQsQ0FENkIsR0FPN0JMLFFBQVFDLE9BQVIsQ0FBZ0IsRUFBaEIsQ0FQSyIsImZpbGUiOiJicm93c2VyLXV0aWxzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIHdpbmRvdywgZG9jdW1lbnQgKi9cbmltcG9ydCBpc0Jyb3dzZXIgZnJvbSAnLi9pcy1icm93c2VyJztcblxuZXhwb3J0IGxldCBpc1BhZ2VMb2FkZWQgPSBmYWxzZTtcblxuZXhwb3J0IGNvbnN0IHBhZ2VMb2FkUHJvbWlzZSA9IGlzQnJvd3NlciA/XG4gIG5ldyBQcm9taXNlKChyZXNvbHZlLCByZWplY3QpID0+IHtcbiAgICB3aW5kb3cub25sb2FkID0gKCkgPT4ge1xuICAgICAgaXNQYWdlTG9hZGVkID0gdHJ1ZTtcbiAgICAgIHJlc29sdmUoZG9jdW1lbnQpO1xuICAgIH07XG4gIH0pIDpcbiAgUHJvbWlzZS5yZXNvbHZlKHt9KTtcblxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist-es6/utils/browser-utils.js
// module id = 576
// module chunks = 0